import React, { useState } from 'react'

import { isFunction } from 'lodash'

import FilesUpload from '../Files/FilesUpload'
import FileTooLargeMessage from '../../shared/Messages/FileTooLargeMessage'
import UnsupportedFileMessage from '../../shared/Messages/UnsupportedFileMessage'
import { ACCEPTED_FILE_TYPES, isFileTooLarge, isFileTypeAccepted } from '../../../utils/files'

const FilesUploader = ({ onUpload, ...props }) => {
  const [tooLargeFile, setTooLargeFile] = useState(null)
  const [unsupportedFile, setUnsupportedFile] = useState(null)

  const handleUpload = (file) => {
    if (isFunction(onUpload)) {
      setTooLargeFile(null)
      setUnsupportedFile(null)

      if (!isFileTypeAccepted(file)) {
        setUnsupportedFile(file)
      } else if (isFileTooLarge(file)) {
        setTooLargeFile(file)
      } else {
        onUpload(file)
      }
    }

    return false
  }

  return (
    <>
      <FilesUpload {...props} accept={ACCEPTED_FILE_TYPES} onUpload={handleUpload} />
      <FileTooLargeMessage file={tooLargeFile} />
      <UnsupportedFileMessage file={unsupportedFile} />
    </>
  )
}

export default FilesUploader
